import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotSection from "./components/HotSection";
import TimelineSection from "./components/TimelineSection";
import MethodSection from "./components/MethodSection";
import MediaSection from "./components/MediaSection";
import BrandSection from "./components/BrandSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";
import { faqs } from "@/mocks/chigua";

function FaqSchema() {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-faq-schema", "true");
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      document.head.querySelectorAll('script[data-faq-schema="true"]').forEach((s) => s.remove());
    };
  }, []);
  return null;
}

export default function Home() {
  return (
    <>
      <FaqSchema />
      <Header />
      <main>
        <Hero />
        <HotSection />
        <TimelineSection />
        <MethodSection />
        <MediaSection />
        <BrandSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}